// code from https://github.com/ueberdosis/tiptap/issues/1061
import { Link } from '@tiptap/extension-link'
import { callOrReturn, markInputRule, markPasteRule } from '@tiptap/core'
import { inputRules, InputRule } from '@tiptap/pm/inputrules'

// These are almost the same as pasteRegex and pasteRegexWithBrackets but with
// additional [\s\n] at the end, so they apply after adding white space or a new line
// added optional http-https upfront
export const pasteRegex = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)/gi
export const linkInputRegex = /((?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*))[\s\n]$/gi
export const linkInputRegexWithBrackets = /(?:\()(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/()]*)(?:\))[\s\n]$/gi

function markInputRuleKeepTrailingChar(regexp, markType, getAttributes) {
  const standardMarkInputRule = markInputRule({ find: regexp, type: markType })

  return new InputRule(regexp, (state, match, start, end) => {
    let range = { from: start, to: end }
    standardMarkInputRule.handler({ state: state, range: range, match: match })
    const { tr } = state
    if (tr) {
      // If the mark has been applied, add the trailing char at the end of the edit
      const attributes = callOrReturn(getAttributes, undefined, match)
      tr.insertText(match[0].slice(-1), end)
      const type = markType.create(attributes || {})
      tr.addMark(range.from, end, type)
    }
    return tr
  })
}

function addPastRule(regexp, markType, getAttributes) {
  return markPasteRule({ find: regexp, type: markType, getAttributes })
}

const addHrefConfig = (callback, index) => matches => {
  callback(matches[index])
  return ({ href: matches[index] })
}

export const AutoLink = Link.extend({
  addPasteRules() {
    const addHref = addHrefConfig(this.options.linkAdded, 0)
    return [
      addPastRule(pasteRegex, this.type, addHref),
      addPastRule(linkInputRegex, this.type, addHref)
    ]
  },
  addProseMirrorPlugins() {
    const addHref = addHrefConfig(this.options.linkAdded, 1)
    const rules = [
      markInputRuleKeepTrailingChar(linkInputRegex, this.type, addHref),
      markInputRuleKeepTrailingChar(linkInputRegexWithBrackets, this.type, addHref)
    ]
    const plugin = inputRules({ rules })
    const run = plugin.props.handleTextInput
    // Based on:
    // https://discuss.prosemirror.net/t/trigger-inputrule-on-enter/1118/5
    plugin.props.handleKeyDown = (view, event) => {
      if (event.key !== 'Enter') {
        return false
      }
      const { $cursor } = view.state.selection
      if ($cursor) {
        return run(view, $cursor.pos, $cursor.pos, '\n')
      }
      // Always return false to keep new line
      return false
    }
    return [plugin]
  }
})
